import { CLM } from "../../../claims";
import { defaultCommandValidator } from "../../_common/validators";
import { ARE_EQUAL, int, optionalInt, optionalText } from "@/fx/data-helpers";
import { LEGACY_CreateDraftClaim_V1 } from "./LEGACY_CreateDraftClaim_V1";

export function createClaimValidator(command: LEGACY_CreateDraftClaim_V1, ctx: {}): boolean {
  const claim = (ctx as any).data.claim as CLM.Claim;
  const claimNumber = claim.claimNumber;

  const { claimNumberOverrides_prefix, claimNumberOverrides_sequence, wholesaler_sapId, distributorLocation, ...commandWithoutOverridesOrDistributorInfo } = command;

  const defaultCommandValidationResult = defaultCommandValidator(commandWithoutOverridesOrDistributorInfo, claim);

  const distributorIsValid = distributorLocation
    ? ARE_EQUAL.id(distributorLocation.id, claim.distributorLocation?.id)
    : ARE_EQUAL.text(optionalText(wholesaler_sapId), optionalText(claim.wholesaler_sapId));

  const { prefix, sequence } = CLM.claimNumberParts({ claimNumber });

  const prefixOverride = optionalInt(claimNumberOverrides_prefix);
  const sequenceOverride = optionalInt(claimNumberOverrides_sequence);

  const isClaimNumberPrefixValid = prefixOverride === undefined || ARE_EQUAL.int(prefixOverride, int(prefix));
  const isClaimNumberSequenceValid = sequenceOverride === undefined || ARE_EQUAL.int(sequenceOverride, int(sequence));

  return isClaimNumberPrefixValid && isClaimNumberSequenceValid && defaultCommandValidationResult && distributorIsValid;
}
